import(/* webpackMode: "eager" */ "/vercel/path0/apps/proportals/src/app/(protected)/(buyer)/page.tsx");
